<template>
  <el-dialog :close-on-click-modal="false" :visible="visible"
             :modal-append-to-body='false' @close="close">
    <el-tabs v-model="viewName">
      <el-tab-pane :label="$t('xiang-qing')" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="$t('ji-ben-xin-xi')" name="basicInformation">
              <el-col :span="24">
                <el-form-item :label="$t('yu-yue-ding-dan-hao')" :label-width="formLabelWidth" prop="appointOrderNo">
                  <label v-text="detailForm.appointOrderNo"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('yun-ying-shang')" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.operatorName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('zhan-dian')" :label-width="formLabelWidth" prop="stationName">
                  <label v-text="detailForm.stationName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('qiang-ming-cheng')" :label-width="formLabelWidth">
                  <label v-text="detailForm.gunName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chong-dian-qiang-bian-hao')" :label-width="formLabelWidth" prop="gunCode">
                  <label v-text="detailForm.gunCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('ke-hu-shou-ji-hao')" :label-width="formLabelWidth" prop="customerPhone">
                  <label v-text="detailForm.customerPhone"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('yu-yue-lai-yuan')" :label-width="formLabelWidth">
                  <label v-text="detailForm.requestSource && detailForm.requestSource.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('yu-yue-chuang-jian-shi-jian')" :label-width="formLabelWidth">
                  <label v-text="detailForm.appointCreateTime"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('yu-yue-jie-shu-shi-jian')" :label-width="formLabelWidth">
                  <label v-text="detailForm.appointCencelTime"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item :title="$t('yu-yue-xin-xi')" name="moreInformation">
              <el-col :span="12">
                <el-form-item :label="$t('yu-yue-zhuang-tai')" :label-width="formLabelWidth">
                  <template v-if="detailForm.appointStateCode && detailForm.appointStateCode !== 1">
                    <label v-text="detailForm.appointState.message"></label>
                  </template>
                  <template v-else-if="detailForm.appointStateCode">
                    <label v-text="detailForm.cencelType.message"></label>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('yu-yue-ti-qian-shi-jian-liang')" :label-width="formLabelWidth">
                  <label v-text="detailForm.appointOvertime + $t('fen')"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('yu-yue-qian-ji-fen')" :label-width="formLabelWidth">
                  <label v-text="detailForm.beforeIntegral"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('zong-gong-xiao-hao-ji-fen')" :label-width="formLabelWidth">
                  <label v-text="detailForm.totalDeductIntegral"></label>
                </el-form-item>
              </el-col>

              <!--<el-col  :span="12">
                <el-form-item label="预约单是否消耗积分：" :label-width="formLabelWidth">
                  <label v-if="detailForm.appointIsDeduct === 'Y'" v-text="'是'"></label>
                  <label v-if="detailForm.appointIsDeduct === 'N'" v-text="'否'"></label>
                </el-form-item>
              </el-col>-->

              <el-col v-if="detailForm.appointIsDeduct === 'Y'" :span="12">
                <el-form-item :label="$t('yu-yue-xiao-hao-ji-fen')" :label-width="formLabelWidth">
                  <label v-text="detailForm.appointDeductIntegral"></label>
                </el-form-item>
              </el-col>


              <template v-if="detailForm.scanTime">
                <el-col :span="12">
                  <el-form-item :label="$t('sao-ma-shu-ma-shua-ka-shi-jian')" :label-width="formLabelWidth">
                    <label v-text="detailForm.scanTime"></label>
                  </el-form-item>
                </el-col>
              </template>
              <el-col v-if="detailForm.chargeOrderNo" :span="12">
                <el-form-item :label="$t('chong-dian-ding-dan-hao')" :label-width="formLabelWidth">
                  <label v-text="detailForm.chargeOrderNo && detailForm.chargeOrderNo"></label>
                </el-form-item>
              </el-col>


              <template v-if="detailForm.appointStateCode && detailForm.appointStateCode === 1">
                <el-col :span="12">
                  <el-form-item :label="$t('qu-xiao-shi-fou-kou-fen')" :label-width="formLabelWidth">
                    <el-switch
                      v-model="detailForm.cencelIsDeduct"
                      active-value="Y"
                      inactive-value="N"
                      disabled></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('qu-xiao-kou-fen')" :label-width="formLabelWidth">
                    <label v-text="detailForm.deductIntegral"></label>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$t('qu-xiao-yu-yue-li-you')" :label-width="formLabelWidth">
                    <label v-text="detailForm.cencelRemarks"></label>
                  </el-form-item>
                </el-col>
              </template>

              <template v-if="detailForm.appointStateCode && detailForm.appointStateCode === 2">
                <el-col :span="12">
                  <el-form-item :label="$t('chao-shi-kou-fen')" :label-width="formLabelWidth">
                    <label v-text="detailForm.deductIntegral"></label>
                  </el-form-item>
                </el-col>
              </template>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
  export default {
    name: "detail",
    props: {
      visible: false,
      detailForm: {}
    },
    data() {
      return {
        viewName: 'detailForm',
        activeNames: ['basicInformation', 'moreInformation'],
        formLabelWidth: '150px',
      }
    },
    methods: {
      close() {
        this.$emit('close', 'detail')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentRecords/detail.vue